import React from 'react';
import {
    Grid,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    InputAdornment,
    Button,
    Box
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

const TeamFilters = ({
    searchQuery,
    setSearchQuery,
    selectedGroup,
    setSelectedGroup,
    selectedLearningStyle,
    setSelectedLearningStyle,
    groups,
    clearFilters
}) => {
    return (
        <Paper sx={{ p: 2, mb: 3 }}>
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ margin: 0 }}>Team Filters</h2>
                <Button
                    startIcon={<FilterAltOffIcon />}
                    onClick={clearFilters}
                    variant="outlined"
                    size="small"
                >
                    Clear Filters
                </Button>
            </Box>
            
            <Grid container spacing={2} alignItems="center">
                {/* Name Search */}
                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        label="Search by Name"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            endAdornment: searchQuery && (
                                <InputAdornment position="end">
                                    <IconButton 
                                        onClick={() => setSearchQuery('')}
                                        size="small"
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>

                {/* Group Filter */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <InputLabel>Filter by Group</InputLabel>
                        <Select
                            value={selectedGroup}
                            onChange={(e) => {
                                console.log('Selected group:', e.target.value);
                                setSelectedGroup(e.target.value);
                            }}
                            label="Filter by Group"
                        >
                            <MenuItem value="all">Show All</MenuItem>
                            {Array.isArray(groups) && groups.map((group) => (
                                <MenuItem key={group.id || group._id} value={group.id || group._id}>
                                    {group.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Updated Learning Style Filter */}
                <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                        <InputLabel>Learning Style</InputLabel>
                        <Select
                            value={selectedLearningStyle}
                            onChange={(e) => setSelectedLearningStyle(e.target.value)}
                            label="Learning Style"
                        >
                            <MenuItem value="all">All Learning Styles</MenuItem>
                            <MenuItem value="visual">
                                Visual Learners
                            </MenuItem>
                            <MenuItem value="auditory">
                                Auditory Learners
                            </MenuItem>
                            <MenuItem value="kinesthetic">
                                Kinesthetic Learners
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default TeamFilters; 